import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SplitButton, SplitButtonItemClickEvent } from '@progress/kendo-react-buttons';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { useCurrentUserContext } from '../../../../../../context/UserContext';

const HierarchyButton: React.FC<ITicketProps> = (ticket) => {
    const navigate = useNavigate();
    const { profile: userProfile } = useCurrentUserContext();
    const [updateHierarchy, { isLoading: updatingTicket, error: saveTicketError }] = TicketApi.useUpdateTicketHierarchyMutation();

    const contextOptions = [
        { text: 'Add Child', key: 'add', visible: ticket.Is_Parent, imageUrl: './images/child.png' },
        { text: 'Make Parent', key: 'parent', visible: (!ticket.Is_Parent && ticket.Parent_Call_Id === null), imageUrl: './images/parent.png' },
        { text: 'Change Hierarchy...', key: 'change', visible: true, icon: 'pencil' }
    ];

    const onItemClick = (event: SplitButtonItemClickEvent) => {
        switch (event.item.key) {
            case 'add':
                navigate('/ticket/new/?parentCallId=' + ticket.ID);
                break;
            case 'parent':
                //Make the current ticekt a parent
                updateHierarchy({ ticketId: ticket.ID, info: { Is_PArent: true, Parent_Ticket_Id: null } }).unwrap().then(() => {
                    //onWindowClose();
                });
                break;
            case 'change':
                navigate('parent-child');
                break;
            default:
                break;
        }
    }

    //if (updatingTicket) return <Spinny />

    return (
        <SplitButton disabled={ticket.Is_Loading || updatingTicket} onItemClick={onItemClick} items={contextOptions.filter(c => c.visible)} onButtonClick={() => navigate('parent-child')} title={ticket?.Is_Parent ? 'Parent ' + userProfile?.Phrases.CallPhrase : ticket?.Parent_Call_Id > 0 ? 'Child ' + userProfile?.Phrases.CallPhrase : 'No hierarchy, click to edit'} imageUrl={ticket?.Is_Parent ? './images/parent.png' : ticket?.Parent_Call_Id > 0 ? './images/child.png' : './images/Toolbar/parent-child.png'} />
    );
};

export default HierarchyButton;